/**
 * Safely extract a human-readable error message from an Axios error.
 * Handles FastAPI/Pydantic validation error arrays ({type, loc, msg, ...}[])
 * and plain string detail fields.
 */
export const getApiErrorMessage = (error, fallback = 'Something went wrong') => {
  const detail = error?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const msgs = detail.map(e => (typeof e === 'string' ? e : e?.msg || JSON.stringify(e)));
    return msgs.join('; ') || fallback;
  }
  if (typeof detail === 'object' && detail.msg) return detail.msg;
  if (typeof detail === 'object' && detail.message) return detail.message;
  return fallback;
};
